<template>
    <form :action="action" method="get" class="buy-energy-header__form" @submit="trackSubmitForm()">
        <div class="buy-energy-header__form__zipcity">
            <ZipCityWithLabel :label="zipCityLabel" :showLabel="false" @change="updateZipCity" />
        </div>
        <div class="buy-energy-header__form__side-by-side">
            <div class="buy-energy-header__form__amount">
                <InputWithLabel :label="amountLabel" :showLabel="false" type="number" :postfix="units" @change="updateAmount" />
            </div>
            <button type="submit" class="buy-energy-header__form__submit">{{buttontext}}</button>
        </div>
        <input type="hidden" name="m" ref="amount" />
        <input type="hidden" name="zip" ref="zipcode" />
        <input type="hidden" name="city" ref="city" />
        <input type="hidden" name="c" ref="coupon" />
    </form>
</template>

<script>
    export default {
        props: {
            action: {
                type: String,
                required: true
            },
            coupon: {
                type: String,
                required: false
            },
            product: {
                type: String,
                required: true
            },
            zipCityLabel: {
                type: String,
                required: true
            },
            amountLabel: {
                type: String,
                required: true
            },
            units: {
                type: String,
                required: true
            },
            buttontext: {
                type: String,
                required: true
            }
        },
        methods: {
            updateZipCity(newVal) {
                this.$refs.zipcode.value = newVal.zipcode;
                this.$refs.city.value = newVal.city;
            },
            updateAmount(newVal) {
                this.$refs.amount.value = newVal;
            },
            trackSubmitForm() {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        'event': 'formular',
                        'formularTyp': 'Energie Kaufen Teaser',
                        'formularName': this.product
                    });
                    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object. (WWW-2077)
                    window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {
                            items: [{
                                item_name: this.product, // Produktname in Shopsprache - Heiz�l, Holzpellets, Diesel
                                item_brand: 'migrol', // Brand des Produktes - falls nicht vorhanden 'migrol'
                                item_category: this.product, // z.B.: Heiz�l, Holzpellets, Diesel
                                quantity: this.$refs.amount.value ? parseInt(this.$refs.amount.value) : null // Menge
                            }]
                        }
                    });
                }
            }
        },
        watch: {
            coupon() {
                this.$refs.coupon.value = this.coupon;
            }
        },
        mounted() {
            this.$refs.coupon.value = this.coupon;
        }
    };
</script>